import styled, { css } from "styled-components";
import {
  fontNormal,
  fontBold,
  fontCondensedNormal
} from "../../_static/Typography";
import buildColor from "../../_static/ColorPalette";

export const OuterContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: transparent;
  z-index: 0;

  @media only screen and (max-width: 767px) {
    min-height: 100vh;
  }
`;

export const InnerContainer = styled.div`
  background-color: ${buildColor("white", "100")};
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 12px;

  @media only screen and (min-width: 768px) {
    flex: none;
    width: 480px;
    align-self: center;
    padding: 20px;
    margin-top: ${({ hasInvalidPromo, hasPromo }) =>
      // eslint-disable-next-line no-nested-ternary
      hasInvalidPromo ? "0" : hasPromo ? "54px" : "40px"};
    border-radius: ${({ hasInvalidPromo }) =>
      hasInvalidPromo ? "0 0 4px 4px" : "4px"};
    margin-bottom: 48px;
  }
`;

export const PromoWrapper = styled.section`
  height: 40px;
  padding: 0;

  @media only screen and (min-width: 768px) {
    display: flex;
    justify-content: center;
    margin-top: 40px;

    & > div {
      width: 480px;
    }
  }
`;

export const InnerSpacingContainer = styled.div`
  @media only screen and (min-width: 768px) {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
`;

export const InnerTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
`;

export const InnerTitle = styled.h2`
  font-family: ${fontBold};
  font-weight: 700;
  font-size: 18px;
`;

export const InnerTitleNote = styled.span`
  display: flex;
  align-items: center;
  font-family: ${fontNormal};
  font-weight: 400;
  font-size: 12px;
  color: ${buildColor("grey", "800")};

  svg {
    margin-right: 4px;
  }
`;

export const InnerInfo = styled.p`
  font-size: 14px;
  font-weight: 400;
  font-family: ${fontNormal};
  color: ${buildColor("grey", "800")};
  margin-bottom: 12px;
`;

export const Background = styled.div`
  position: fixed;
  display: flex;
  z-index: -1;
  padding-top: 38px;
  height: 100%;
  width: 100%;
  background: linear-gradient(180deg, #112b44 0%, #1a4066 100%);
  justify-content: center;

  @media only screen and (min-width: 768px) {
    padding-top: 24px;
  }
`;

export const ImageRain = styled.img`
  position: absolute;
  width: 1280px;
  height: 400px;

  @media only screen and (max-width: 767px) {
    width: 400px;
    height: 180px;
  }

  @media only screen and (min-width: 768px) and (orientation: landscape) {
    height: auto;
  }

  @media only screen and (min-width: 1024px) {
    height: 500px;
  }
`;

export const ListRow = styled.div`
  display: flex;
  align-items: center;
  margin-top: 16px;
`;

export const RowText = styled.p`
  flex: 1;
  display: flex;
  align-items: center;
  margin-left: 4px;
  line-height: 16px;
  font-size: 12px;
  font-family: ${fontNormal};
  color: ${buildColor("grey", "800")};
`;
